import { Component, OnInit, Injector, Input, Inject } from '@angular/core';
import { WorkOrderScheduleEditService } from '../work-order-schedule-edit.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

const PLACEHOLDER = 'placeholder';

@Component({
  selector: 'work-order-schedule-add',
  templateUrl: './work-order-schedule-add.component.html',
  styleUrls: ['./work-order-schedule-add.component.scss']
})
export class WorkOrderScheduleAddComponent implements OnInit {
  data: any = {};
  public readonly workOrderScheduleEditService: WorkOrderScheduleEditService;
  public isVacationCreation = false;
  public formGroup: UntypedFormGroup;
  formBuilder: UntypedFormBuilder;

  constructor(
    private readonly injector: Injector,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<WorkOrderScheduleAddComponent>,
  ) {
    this.workOrderScheduleEditService = injector.get(WorkOrderScheduleEditService);
    this.formBuilder = this.injector.get(UntypedFormBuilder);
    this.data = data;
    this.formGroup = this.formBuilder.group(this.data.formGroup);
    if (!this.formGroup.controls['isVacation']) {
      this.formGroup.controls['StudyTitle'].disable();
    }
    if (this.formGroup.get('isVacation').value) {
      this.formGroup.get('WorkOrderId').setValue(PLACEHOLDER);
    }
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  /**
     * Switches between vacation editing.
     * True: vacation editing
     * False: work order editing
     *
     * @param {*} isVacationEditing
     * @memberof WorkOrderScheduleComponent
     */
  switchEditMode(isVacationEditing) {
    this.isVacationCreation = isVacationEditing;
    this.formGroup.get('isVacation').setValue(isVacationEditing);
    this.formGroup.get('workOrderNumber').setValue(null);
    this.formGroup.get('WorkOrderId').setValue(null);
    this.formGroup.get('ProgramId').setValue(null);
    this.formGroup.get('programCode').setValue(null);
    this.formGroup.get('StudyTitle').setValue(null);

    if (isVacationEditing && !this.formGroup.get('WorkOrderId').value) {
      this.formGroup.get('WorkOrderId').setValue(PLACEHOLDER);
    }
  }

  onYesClick(): any {
    this.dialogRef.close([this.formGroup.value]);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  workOrderSelectionChange(workOrder) {
    const selectedWorkOrder = this.workOrderScheduleEditService.workOrderServiceFilterable
      .value.find(x => x.WorkOrderId === workOrder.value);
    this.formGroup.get('StudyTitle').setValue(selectedWorkOrder.StudyTitle);
  }

  programSelectionChange(program) {
    this.formGroup.get('workOrderNumber').setValue(null);
    this.formGroup.get('WorkOrderId').setValue(null);
    this.formGroup.get('StudyTitle').setValue(null);
  }

  isDisabled() {
    return !this.formGroup.valid;
  }
}


